(function () {
    'use strict';

    var app = angular.module('app');

    // Collect the routes
    app.constant('routes', getRoutes());

    // Configure the routes and route resolvers
    app.config(['$routeProvider', 'routes', routeConfigurator]);
    function routeConfigurator($routeProvider, routes) {

        routes.forEach(function (r) {
            $routeProvider.when(r.url, r.config);
        });
        $routeProvider.otherwise({ redirectTo: '/' });
    }

    // Define the routes 
    function getRoutes() {
        return [
            {
                url: '/dashboard_Super',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Super.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Admin',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Admin.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Gestore',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Gestore.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Stakeholder',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Stakeholder.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Docente',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Docente.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Stakeholder',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Stakeholder.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Monitor',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Gestore.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Studente',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Studente.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/dashboard_Commercial',
                config: {
                    title: 'dashboard',
                    templateUrl: '/app/dashboard/dashboard_Commercial.html?version=43',
                    slug: 'page-dashboard'
                }
            },
            {
                url: '/logout',
                config: {
                    title: 'error',
                    templateUrl: '/app/logout/logout.html',
                    slug: 'error'
                }
            },
            {
                url: '/',
                config: {
                    title: 'empty',
                    templateUrl: '/app/layout/empty.html',
                    slug: 'error'
                }
            },
            //********************************
            //AVVISO
            {
                url: '/avviso',
                config: {
                    title: 'avvisi',
                    templateUrl: '/app/avviso/avvisi.html?version=43',
                    slug: 'page-avvisi'
                }
            },
            {
                url: '/avviso/:AvvisoId',
                config: {
                    title: 'avvisoDetail',
                    templateUrl: '/app/avviso/avvisi.html?version=43',
                    slug: 'page-avvisi'
                }
            },
            //********************************
            //AGGIORNAMENTO
            {
                url: '/aggiornamento',
                config: {
                    title: 'aggiornamenti',
                    templateUrl: '/app/aggiornamento/aggiornamenti.html?version=43',
                    slug: 'page-avvisi'
                }
            },
            {
                url: '/aggiornamento/:AggiornamentoId',
                config: {
                    title: 'aggiornamentoDetail',
                    templateUrl: '/app/aggiornamento/aggiornamenti.html?version=43',
                    slug: 'page-aggiornamenti'
                }
            },
            //********************************
            //CLASSE
            {
                url: '/classe',
                config: {
                    title: 'classi',
                    templateUrl: '/app/classe/classi.html?version=43',
                    slug: 'page-classi'
                }
            },
            {
                url: '/classe/:ClasseId',
                config: {
                    title: 'classeDetail',
                    templateUrl: '/app/classe/classi.html?version=43',
                    slug: 'page-classi'
                }
            },
            //CLASSE DOCENTE
            {
                url: '/classeDoc',
                config: {
                    title: 'classi',
                    templateUrl: '/app/classeDoc/classi.html?version=43'
                }
            },
            {
                url: '/classeDoc/:ClasseId',
                config: {
                    title: 'classeDetail',
                    templateUrl: '/app/classeDoc/classi.html?version=43'
                }
            },
            //CLIENTE
            {
                url: '/cliente',
                config: {
                    title: 'clienti',
                    templateUrl: '/app/cliente/cliente.html?version=43'
                }
            },
            {
                url: '/cliente/:ClienteId',
                config: {
                    title: 'cliente',
                    templateUrl: '/app/cliente/cliente.html?version=43'
                }
            },
            //COMMERCIALE 
            {
                url: '/commerciale',
                config: {
                    title: 'commerciali',
                    templateUrl: '/app/commerciale/commerciali.html?version=43'
                }
            }, {
                url: '/commerciale/:CommercialeId',
                config: {
                    title: 'commercialeDetail',
                    templateUrl: '/app/commerciale/commerciali.html?version=43'
                }
            },
            //ORDINE
            {
                url: '/ordine',
                config: {
                    title: 'ordine',
                    templateUrl: '/app/ordine/ordini.html?version=43'
                }
            }, {
                url: '/ordine/:OrdineId',
                config: {
                    title: 'ordineDetail',
                    templateUrl: '/app/ordine/ordini.html?version=43'
                }
            },
            // RIEPILOGO ORDINE
            {
                url: '/riepilogoOrdine',
                config: {
                    title: 'riepilogoOrdine',
                    templateUrl: '/app/riepilogoOrdine/riepilogoOrdini.html?version=43'
                }
            },
            //PAGAMENTO
            {
                url: '/pagamento',
                config: {
                    title: 'pagamento',
                    templateUrl: '/app/pagamento/pagamenti.html?version=43'
                }
            }, {
                url: '/pagamento/:PagamentoId',
                config: {
                    title: 'pagamentoDetail',
                    templateUrl: '/app/pagamento/pagamenti.html?version=43'
                }
            },
            //FAQ
            {
                url: '/faq',
                config: {
                    title: 'faq',
                    templateUrl: '/app/faq/faq.html?version=43'
                }
            },
            //LISTINO
            {
                url: '/listino',
                config: {
                    title: 'listino',
                    templateUrl: '/app/listino/listini.html?version=43'
                }
            }, {
                url: '/listino/:ListinoId',
                config: {
                    title: 'listinoDetail',
                    templateUrl: '/app/listino/listini.html?version=43'
                }
            },
            //CONTO CORRENTE
            {
                url: '/contoCorrente',
                config: {
                    title: 'contoCorrente',
                    templateUrl: '/app/contoCorrente/contiCorrenti.html?version=43'
                }
            }, {
                url: '/contoCorrente/:contoCorrenteId',
                config: {
                    title: 'contoCorrenteDetail',
                    templateUrl: '/app/contoCorrente/contiCorrenti.html?version=43'
                }
            },
            //CONTRATTO
            {
                url: '/contratto',
                config: {
                    title: 'contratto',
                    templateUrl: '/app/contratto/contratti.html?version=43'
                }
            }, {
                url: '/contratto/:ContrattoId',
                config: {
                    title: 'contrattoDetail',
                    templateUrl: '/app/contratto/contratti.html?version=43'
                }
            },

            //ACQUISTO
            {
                url: '/acquisto',
                config: {
                    title: 'acquisti',
                    templateUrl: '/app/acquisto/acquisti.html?version=43'
                }
            },
            //CORSO
            {
                url: '/corso',
                config: {
                    title: 'corsi',
                    templateUrl: '/app/corso/corsi.html?version=43'
                }
            },
            {
                url: '/corso/:CorsoId',
                config: {
                    title: 'corso',
                    templateUrl: '/app/corso/corsi.html?version=43'
                }
            },
            //INCARICO
            {
                url: '/incarico',
                config: {
                    title: 'incarichi',
                    templateUrl: '/app/incarico/incarichi.html?version=43'
                }
            }, {
                url: '/incarico/:IncaricoId',
                config: {
                    title: 'incaricoDetail',
                    templateUrl: '/app/incarico/incaricoDetail.html?version=43'
                }
            },
            //INCONTRO
            {
                url: '/incontro',
                config: {
                    title: 'incontri',
                    templateUrl: '/app/incontro/incontri.html?version=43'
                }
            }, {
                url: '/incontro/:IncontroId',
                config: {
                    title: 'incontroDetail',
                    templateUrl: '/app/incontro/incontroDetail.html?version=43'
                }
            },
            //ISTITUTO
            {
                url: '/istituto',
                config: {
                    title: 'istituti',
                    templateUrl: '/app/istituto/istituti.html?version=43'
                }
            }, {
                url: '/istituto/:IstitutoId',
                config: {
                    title: 'istitutoDetail',
                    templateUrl: '/app/istituto/istituti.html?version=43'
                }
            },
            //LEZIONE
            {
                url: '/lezione',
                config: {
                    title: 'lezioni',
                    templateUrl: '/app/lezione/lezioni.html?version=43'
                }
            }, {
                url: '/lezione/:LezioneId',
                config: {
                    title: 'lezioneDetail',
                    templateUrl: '/app/lezione/lezioneDetail.html?version=43'
                }
            },
            {
                url: '/lezioneDoc',
                config: {
                    title: 'lezioni',
                    templateUrl: '/app/lezioneDoc/lezioni.html?version=43'
                }
            },
            {
                url: '/lezioneElenco',
                config: {
                    title: 'lezioni elenco',
                    templateUrl: '/app/lezioneElenco/lezioniElenco.html?version=43'
                }
            },
            //LICENZA
            {
                url: '/licenza',
                config: {
                    title: 'licenza',
                    templateUrl: '/app/licenza/licenza.html?version=43'
                }
            },
            //PROFILO
            {
                url: '/profilo',
                config: {
                    title: 'profilo',
                    templateUrl: '/app/profilo/profilo.html?version=43'
                }
            },
            //TUTORIAL
            {
                url: '/tutorial',
                config: {
                    title: 'tutorial',
                    templateUrl: '/app/tutorial/tutorial.html?version=43'
                }
            }, {
                url: '/tutorial/:TutorialId',
                config: {
                    title: 'tutorialDetail',
                    templateUrl: '/app/tutorial/tutorial.html?version=43'
                }
            },

            //TUTORIALDOC
            {
                url: '/tutorialDoc',
                config: {
                    title: 'tutorial',
                    templateUrl: '/app/tutorialDoc/tutorial.html?version=43'
                }
            },

            //MATERIA
            {
                url: '/materia',
                config: {
                    title: 'materia',
                    templateUrl: '/app/materia/materie.html?version=43'
                }
            }, {
                url: '/materia/:MateriaId',
                config: {
                    title: 'materiaDetail',
                    templateUrl: '/app/materia/materia.html?version=43'
                }
            },
            //DIDATTICA PER COMPETENZE
            {
                url: '/schedaCompetenze',
                config: {
                    title: 'schedaCompetenze',
                    templateUrl: '/app/schedaCompetenze/schedeCompetenze.html?version=43'
                }
            }, {
                url: '/schedaCompetenze/:schedaCompetenzeId',
                config: {
                    title: 'schedaCompetenzeDetail',
                    templateUrl: '/app/schedaCompetenze/schedeCompetenze.html?version=43'
                }
            },
            //SOCIETA
            {
                url: '/societa',
                config: {
                    title: 'societa',
                    templateUrl: '/app/societa/societa.html?version=43'
                }
            },
            {
                url: '/societa/:SocietaId',
                config: {
                    title: 'societaDetail',
                    templateUrl: '/app/societa/societa.html?version=43'
                }
            },
            //RISORSA 
            {
                url: '/risorsa',
                config: {
                    title: 'risorse',
                    templateUrl: '/app/risorsa/risorse.html?version=43'
                }
            },
            {
                url: '/risorsa/:RisorsaId',
                config: {
                    title: 'risorsaDetail',
                    templateUrl: '/app/risorsa/risorse.html?version=43'
                }
            },
            //STAKEHOLDER 
            {
                url: '/stakeholder',
                config: {
                    title: 'stakeholders',
                    templateUrl: '/app/stakeholder/stakeholders.html?version=43'
                }
            },
            {
                url: '/stakeholder/:stakeholderId',
                config: {
                    title: 'stakeholderDetail',
                    templateUrl: '/app/stakeholder/stakeholders.html?version=43'
                }
            },
            //STUDENTE
            {
                url: '/studente',
                config: {
                    title: 'studenti',
                    templateUrl: '/app/studente/studenti.html?version=43'
                }
            },
            {
                url: '/studente/:StudenteId',
                config: {
                    title: 'studenteDetail',
                    templateUrl: '/app/studente/studenti.html?version=43'
                }
            },
            //STUDENTE DOCENTE
            {
                url: '/studenteDoc',
                config: {
                    title: 'studenti',
                    templateUrl: '/app/studenteDoc/studenti.html?version=43'
                }
            },
            {
                url: '/studenteDoc/:StudenteId',
                config: {
                    title: 'studenteDetail',
                    templateUrl: '/app/studenteDoc/studenti.html?version=43'
                }
            },
            //USER
            {
                url: '/user',
                config: {
                    title: 'users',
                    templateUrl: '/app/user/users.html?version=43'
                }
            },
            {
                url: '/user/:UserId',
                config: {
                    title: 'userDetail',
                    templateUrl: '/app/user/users.html?version=43'
                }
            },
            //FATTURA PA
            {
                url: '/fatturapa',
                config: {
                    title: 'fatturapa',
                    templateUrl: '/app/fatturapa/fatturapa.html?version=43',
                    slug: 'page-fatturapa'
                }
            },
            {
                url: '/fatturapa/:FatturaId',
                config: {
                    title: 'fatturapaDetail',
                    templateUrl: '/app/fatturapa/fatturapa.html?version=43',
                    slug: 'page-fatturapa'
                }
            },
            //MONITORAGGIO
            {
                url: '/monitoraggio',
                config: {
                    title: 'monitoraggio',
                    templateUrl: '/app/monitoraggio/monitoraggio.html?version=43'
                }
            },
            //SISTEMA   
            {
                url: '/sistema',
                config: {
                    title: 'sistema',
                    templateUrl: '/app/sistema/sistema.html?version=43'
                }
            },
            //LOGS   
            {
                url: '/logs',
                config: {
                    title: 'logs',
                    templateUrl: '/app/logPush/logPush.html?version=43'
                }
            },
            //COMMUNITY
            {
                url: '/community',
                config: {
                    title: 'community',
                    templateUrl: '/app/community/community.html?version=43',
                    slug: 'community'
                }
            },
            //ATTACH
            //{
            //    url: '/attach',
            //    config: {
            //        title: 'attach',
            //        templateUrl: '/app/attach/attach.html?version=43'
            //    }
            //},
            //{
            //    url: '/attach/:AttachId',
            //    config: {
            //        title: 'attach',
            //        templateUrl: '/app/attach/attach.html?version=43'
            //    }
            //},
            //T_ATTACH
            {
                url: '/tAttach',
                config: {
                    title: 'tAttach',
                    templateUrl: '/app/tAttach/tAttach.html?version=43'
                }
            },
            {
                url: '/tAttach/:TAttachId',
                config: {
                    title: 'tAttach',
                    templateUrl: '/app/tAttach/tAttach.html?version=43'
                }
            },
            //CLASSE DOCENTE
            {
                url: '/didatticaCompetenze',
                config: {
                    title: 'didattiche',
                    templateUrl: '/app/didatticaCompetenze/didattiche.html?version=43'
                }
            },
            {
                url: '/didatticaCompetenze/:DidatticheId',
                config: {
                    title: 'didatticaDetail',
                    templateUrl: '/app/didatticaCompetenze/didattiche.html?version=43'
                }
            },
            /*******************************************************/
            /*  ADMIN SL                                           */
            /*******************************************************/
            //Istituti
            {
                url: '/asl_istituto',
                config: {
                    title: 'istituti',
                    templateUrl: '/app/adminSL/societa/asl_societa.html?version=43'
                }
            },
            {
                url: '/asl_istituto/:societaId',
                config: {
                    title: 'istitutoDetail',
                    templateUrl: '/app/adminSL/societa/asl_societa.html?version=43'
                }
            },
            //Risorse 
            {
                url: '/asl_risorsa',
                config: {
                    title: 'risorse',
                    templateUrl: '/app/adminSL/risorsa/asl_risorse.html?version=43'
                }
            },
            {
                url: '/asl_risorsa/:RisorsaId',
                config: {
                    title: 'risorsaDetail',
                    templateUrl: '/app/adminSL/risorsa/asl_risorse.html?version=43'
                }
            },
            //Studenti 
            {
                url: '/asl_studente',
                config: {
                    title: 'studente',
                    templateUrl: '/app/adminSL/studente/asl_studenti.html?version=43'
                }
            },
            {
                url: '/asl_studente/:StudenteId',
                config: {
                    title: 'studenteDetail',
                    templateUrl: '/app/adminSL/studente/asl_studenti.html?version=43'
                }
            },
            //Stakeholders 
            {
                url: '/asl_stakeholder',
                config: {
                    title: 'stakeholder',
                    templateUrl: '/app/adminSL/stakeholder/asl_stakeholders.html?version=43'
                }
            },
            {
                url: '/asl_stakeholder/:StakeholderId',
                config: {
                    title: 'stakeholderDetail',
                    templateUrl: '/app/adminSL/stakeholder/asl_stakeholders.html?version=43'
                }
            },
            // Test
            {
                url: '/asl_test',
                config: {
                    title: 'test',
                    templateUrl: '/app/adminSL/test/asl_tests.html?version=43'
                }
            },
            {
                url: '/asl_test/:testId',
                config: {
                    title: 'testDetail',
                    templateUrl: '/app/adminSL/test/tests.html?version=43'
                }
            },
            // Pacchetto
            {
                url: '/asl_pacchetto',
                config: {
                    title: 'pacchetto',
                    templateUrl: '/app/adminSL/pacchetto/asl_pacchetti.html?version=43'
                }
            },
            {
                url: '/asl_pacchetto/:pacchettoId',
                config: {
                    title: 'pacchettoDetail',
                    templateUrl: '/app/adminSL/pacchetto/pacchetti.html?version=43'
                }
            },
            // Sessioni
            {
                url: '/asl_session',
                config: {
                    title: 'session',
                    templateUrl: '/app/adminSL/session/asl_sessions.html?version=43'
                }
            },
            {
                url: '/asl_session/:sessionId',
                config: {
                    title: 'sessionDetail',
                    templateUrl: '/app/adminSL/session/asl_sessions.html?version=43'
                }
            },
            // Ordini
            {
                url: '/asl_ordine',
                config: {
                    title: 'ordine',
                    templateUrl: '/app/adminSL/ordine/asl_ordini.html?version=43'
                }
            }, {
                url: '/asl_ordine/:OrdineId',
                config: {
                    title: 'ordineDetail',
                    templateUrl: '/app/adminSL/ordine/asl_ordini.html?version=43'
                }
            },
            //Fattura PA
            {
                url: '/asl_fatturapa',
                config: {
                    title: 'fatturapa',
                    templateUrl: '/app/adminSL/fatturapa/asl_fatturapa.html?version=43',
                    slug: 'page-fatturapa'
                }
            },
            {
                url: '/asl_fatturapa/:FatturaId',
                config: {
                    title: 'fatturapaDetail',
                    templateUrl: '/app/adminSL/fatturapa/asl_fatturapa.html?version=43',
                    slug: 'page-fatturapa'
                }
            },
            {
                /*LEGGENDA Area */
                // 1: test condivisi
                // 2: test acquistati
                // null: test
                url: '/asl_question/:questionId/:testId/:area',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/adminSL/question/questions.html?version=43'
                }
            },
            //
            //Cookies
            {
                url: '/cookie',
                config: {
                    title: 'corsi',
                    templateUrl: '/app/cookie/cookie.html?version=43'
                }
            },
            /*******************************************************/
            /*  EDUP                                               */
            /*******************************************************/
            //EDUP Question
            {
                url: '/EDUP_question',
                config: {
                    title: 'question',
                    templateUrl: '/app/EDUP_question/questions.html?version=43'
                }
            },
            {
                url: '/EDUP_question/:questionId/:testId',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/EDUP_question/questions.html?version=43'
                }
            },
            {
                url: '/EDUP_question/:questionId/:testId/:readonly',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/EDUP_question/questions.html?version=43'
                }
            },
            {
                url: '/EDUP_question/:questionId/:testId/:readonly/:testAllievi',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/EDUP_question/questions.html?version=43'
                }
            },
            //EDUP Test
            {
                url: '/EDUP_test',
                config: {
                    title: 'test',
                    templateUrl: '/app/EDUP_test/tests.html?version=43'
                }
            }, {
                url: '/EDUP_test/:testId',
                config: {
                    title: 'testDetail',
                    templateUrl: '/app/EDUP_Test/tests.html?version=43'
                }
            },
            //EDUP TestAllievi
            {
                url: '/EDUP_testAllievi',
                config: {
                    title: 'test',
                    templateUrl: '/app/EDUP_TestAllievi/tests.html?version=43'
                }
            },
            {
                url: '/EDUP_testAllievi/:testId',
                config: {
                    title: 'testDetail',
                    templateUrl: '/app/EDUP_TestAllievi/tests.html?version=43'
                }
            },
            //EDUP Session
            {
                url: '/EDUP_session',
                config: {
                    title: 'session',
                    templateUrl: '/app/EDUP_session/sessions.html?version=43'
                }
            },
            {
                url: '/EDUP_session/:sessionId',
                config: {
                    title: 'sessionDetail',
                    templateUrl: '/app/EDUP_session/sessions.html?version=43'
                }
            },
            {
                url: '/EDUP_session/:testId/:testTitle',
                config: {
                    title: 'sessionDetail',
                    templateUrl: '/app/EDUP_session/sessions.html?version=43'
                }
            },
            //EDUP Studente Session
            {
                url: '/EDUP_StudSession',
                config: {
                    title: 'studSession',
                    templateUrl: '/app/EDUP_StudSession/studSessions.html?version=43'
                }
            },
            //EDUP Test colleghi
            {
                url: '/EDUP_testColleghi',
                config: {
                    title: 'testColleghi',
                    templateUrl: '/app/EDUP_testColleghi/tests.html?version=43'
                }
            },
            {
                url: '/EDUP_testColleghi/:testId',
                config: {
                    title: 'testColleghiDetail',
                    templateUrl: '/app/EDUP_testColleghi/tests.html?version=43'
                }
            },
            //EDUP Test acquistati
            {
                url: '/EDUP_testAcquistati',
                config: {
                    title: 'testAcquistati',
                    templateUrl: '/app/EDUP_TestAcquistati/tests.html?version=43'
                }
            },
            {
                url: '/EDUP_testAcquistati/:testId',
                config: {
                    title: 'testAcquistatiDetail',
                    templateUrl: '/app/EDUP_TestAcquistati/tests.html?version=43'
                }
            },

            /*******************************************************/
            /*  STAK                                               */
            /*******************************************************/
            //STAK Question
            {
                url: '/STAK_question/:questionId/:testId/:pacchettoId',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/STAK_question/questions.html?version=43'
                }
            }, {
                url: '/STAK_question/:questionId/:testId/:pacchettoId/:readonly',
                config: {
                    title: 'questionDetail',
                    templateUrl: '/app/STAK_question/questions.html?version=43'
                }
            },

            //STAK Test
            {
                url: '/STAK_test',
                config: {
                    title: 'test',
                    templateUrl: '/app/STAK_test/tests.html?version=43'
                }
            }, {
                url: '/STAK_test/:testId',
                config: {
                    title: 'testDetail',
                    templateUrl: '/app/STAK_Test/tests.html?version=43'
                }
            }, {
                url: '/STAK_test/:testId/:pacchettoId',
                config: {
                    title: 'testDetail',
                    templateUrl: '/app/STAK_test/tests.html?version=43'
                }
            },

            //STAK_PROFILO
            {
                url: '/STAK_profilo',
                config: {
                    title: 'profilo',
                    templateUrl: '/app/STAK_profilo/profilo.html?version=43'
                }
            },
            //STAK_ACCOUNT
            {
                url: '/STAK_account',
                config: {
                    title: 'account',
                    templateUrl: '/app/STAK_account/account.html?version=43'
                }
            },

            //Pacchetto
            {
                url: '/pacchetto',
                config: {
                    title: 'pacchetto',
                    templateUrl: '/app/pacchetto/pacchetti.html?version=43'
                }
            }, {
                url: '/pacchetto/:pacchettoId',
                config: {
                    title: 'pacchettoDetail',
                    templateUrl: '/app/pacchetto/pacchetti.html?version=43'
                }
            }, {
                url: '/pacchetto/:pacchettoId/:testId',
                config: {
                    title: 'pacchettoDetail',
                    templateUrl: '/app/pacchetto/pacchetti.html?version=43'
                }
            },

            //********************************
            //TIPO LICENZA
            {
                url: '/tipoLicenza',
                config: {
                    title: 'tipoLicenze',
                    templateUrl: '/app/tipoLicenza/tipoLicenze.html?version=43',
                    slug: 'page-tipoLicenze'
                }
            },
            {
                url: '/tipoLicenza/:TipoLicenzaId',
                config: {
                    title: 'tipoLicenzaDetail',
                    templateUrl: '/app/tipoLicenza/tipoLicenze.html?version=43',
                    slug: 'page-tipoLicenze'
                }
            }
        ];
    }
})();